import service from '../service/service'
import CONSTANT from '../constant/service'
import _ from 'underscore'

export default {
  getServiceQuestionDetail ({commit}, data) {
    return new Promise((resolve, reject) => {
      return service.getQuestionDetail(data).then(result => {
        commit(CONSTANT.SERVICE_GETQUESTIONDETAIL_SUCCESS, result)
        return resolve(result)
      }, e => {
        reject(e)
        commit(CONSTANT.SERVICE_GETQUESTIONDETAIL_ERROR, e)
      })
    })
  },
  getServiceQuestionList ({commit}, data) {
    return new Promise((resolve, reject) => {
      return service.getQuestionList(data).then(result => {
        commit(CONSTANT.SERVICE_GETQUESTIONLIST_SUCCESS, result || {})
        return resolve(result.list || [])
      }, e => {
        reject(e)
        commit(CONSTANT.SERVICE_GETQUESTIONLIST_ERROR, e)
      })
    })
  },
}
